module.exports = __webpack_public_path__ + "img/error.119abd4e.svg";